package com.imobly.imobly.api.dto.viacep

import kotlinx.serialization.Serializable

@Serializable
data class ViaCepDTO(
    val estado: String = "",
    val localidade: String = "",
    val bairro: String = "",
    val logradouro: String ="",
    val erro: Boolean = false
): ResponseMessageViaCep()